<template>
  <div>
    <!-- 基本信息 -->
    <el-form :model="newform" :rules="formRule" ref="formRef">
      <div class="inputList">
        <p class="view_head midflex">1.企业信息</p>
        <h6>1.1基本信息</h6>
        <table border="1" style="width: 95%" class="newtable">
          <tbody>
            <tr>
              <td>企业名称</td>
              <td colspan="3">
                <el-form-item prop="company_name">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.company_name"
                    @change="labelInput($event, 'company_name')"
                  />
                </el-form-item>
              </td>
            </tr>

            <tr>
              <td>申报类型</td>
              <td colspan="3">
                <el-form-item prop="company_name">
                  <el-checkbox-group v-model="newform.apply_type">
                    <el-checkbox label="1"
                      >首次申报(包括未续期、断档企业)</el-checkbox
                    >
                    <el-checkbox label="2"
                      >续评企业(2025年12月2日到期的诚信企业或AAA信用企业)</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>注册地址</td>
              <td colspan="3">
                <el-form-item prop="reg_add">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.reg_add"
                    @change="labelInput($event, 'reg_add')"
                  />
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>经营地址</td>
              <td colspan="3">
                <el-form-item prop="bus_add">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.bus_add"
                    @change="labelInput($event, 'bus_add')"
                  />
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>成立时间</td>
              <td colspan="3">
                <el-form-item prop="birth_date">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.birth_date"
                    @change="labelInput($event, 'birth_date')"
                  />
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>统一社会信用代码</td>
              <td colspan="3">
                <el-form-item prop="taxnum">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.taxnum"
                    @change="labelInput($event, 'taxnum')"
                  />
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>法定代表人</td>
              <td>
                <el-form-item prop="legaler">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.legaler"
                    @change="labelInput($event, 'legaler')"
                  />
                </el-form-item>
              </td>
              <td>注册资本金</td>
              <td>
                <el-form-item prop="reg_money">
                  <input
                    type="number"
                    placeholder="请输入"
                    v-model="newform.reg_money"
                    @change="labelInput($event, 'reg_money')"
                  />
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>经营范围</td>
              <td>
                <el-form-item prop="bus_range">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.bus_range"
                    @change="labelInput($event, 'bus_range')"
                  />
                </el-form-item>
              </td>
              <td>经济性质</td>
              <td>
                <el-form-item prop="ec_nature">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.ec_nature"
                    @change="labelInput($event, 'ec_nature')"
                  />
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>上一年度竣工工程数量</td>
              <td>
                <el-form-item prop="over_num">
                  <input
                    type="number"
                    placeholder="请输入"
                    v-model="newform.over_num"
                    @change="labelInput($event, 'over_num')"
                  />个
                </el-form-item>
              </td>
              <td>工程质量验收合格率</td>
              <td>
                <el-form-item prop="pass_rate">
                  <input
                    type="number"
                    placeholder="请输入"
                    v-model="newform.pass_rate"
                    @change="labelInput($event, 'pass_rate')"
                  />%
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>申报人姓名</td>
              <td>
                <el-form-item prop="contacts_name">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.contacts_name"
                    @change="labelInput($event, 'contacts_name')"
                  />
                </el-form-item>
              </td>
              <td>申报人职务</td>
              <td>
                <el-form-item prop="contacts_post">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.contacts_post"
                    @change="labelInput($event, 'contacts_post')"
                  />
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>申报人电话</td>
              <td>
                <el-form-item prop="contacts_phone">
                  <input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.contacts_phone"
                    @change="labelInput($event, 'contacts_phone')"
                  />
                </el-form-item>
              </td>
              <td>申报人手机</td>
              <td>
                <el-form-item prop="cellphone">
                  <input
                    type="number"
                    placeholder="请输入"
                    v-model="newform.cellphone"
                    @change="labelInput($event, 'cellphone')"
                  />
                </el-form-item>
              </td>
            </tr>
          </tbody>
        </table>

        <p>1.2法定代表人信息</p>
        <div>
          <table border="1" style="width: 100%" class="newtable">
            <tbody>
              <tr>
                <td>姓名</td>
                <td>性别</td>
                <td>年龄</td>
                <td>职务</td>
                <td>学历</td>
                <td>职称</td>
              </tr>
              <tr>
                <td>
                  <el-form-item prop="legal_name"
                    ><input
                      type="text"
                      placeholder="请输入"
                      v-model="newform.legal_name"
                      @change="labelInput($event, 'legal_name')"
                    />
                  </el-form-item>
                </td>
                <td>
                  <el-form-item prop="legal_sex"
                    ><input
                      type="text"
                      placeholder="请输入"
                      v-model="newform.legal_sex"
                      @change="labelInput($event, 'legal_sex')"
                  /></el-form-item>
                </td>
                <td>
                  <el-form-item prop="legal_age"
                    ><input
                      type="number"
                      placeholder="请输入"
                      v-model="newform.legal_age"
                      @change="labelInput($event, 'legal_age')"
                  /></el-form-item>
                </td>
                <td>
                  <el-form-item prop="legal_post">
                    <input
                      type="text"
                      placeholder="请输入"
                      v-model="newform.legal_post"
                      @change="labelInput($event, 'legal_post')"
                  /></el-form-item>
                </td>
                <td>
                  <el-form-item prop="legal_education"
                    ><input
                      type="text"
                      placeholder="请输入"
                      v-model="newform.legal_education"
                      @change="labelInput($event, 'legal_education')"
                  /></el-form-item>
                </td>
                <td>
                  <el-form-item prop="legal_title"
                    ><input
                      type="text"
                      placeholder="请输入"
                      v-model="newform.legal_title"
                      @change="labelInput($event, 'legal_title')"
                  /></el-form-item>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p>1.3资质及资格</p>
        <!--          <div class="newAddBtn" style="margin-left: 50px;margin-bottom: 10px">
            <el-button type="primary" @click="addInstall('quaList')">增行</el-button>
          </div>-->
        <table border="1" style="width: 95%" class="newtable">
          <tbody>
            <tr>
              <td>序号</td>
              <td>
                资质类别及等级
                <!--                <div class="newAddBtn" style="margin-left: 50px;margin-bottom: 10px">-->
                <el-button type="primary" @click="addInstall('quaList')"
                  >增行</el-button
                >
                <!--                </div>-->
              </td>
              <td>证书编号</td>
              <td>有效期</td>
              <td>动作</td>
            </tr>

            <tr v-for="(item, index) in newform.quaList" :key="index">
              <td>{{ index + 1 }}</td>
              <td>
                <el-input
                  placeholder="请输入"
                  type="text"
                  v-model="newform.quaList[index].qualification_category"
                ></el-input>
                <span style="font-size: 12px;color: red;"
                  >此行填写企业最高等级资质，先写总承包资质，再填写专业承包资质</span
                >
              </td>
              <td>
                <el-input
                  placeholder="请输入"
                  type="text"
                  v-model="newform.quaList[index].cert_num"
                ></el-input>
              </td>
              <td>
                <el-input
                  placeholder="请输入"
                  type="text"
                  v-model="newform.quaList[index].cert_expiretime"
                ></el-input>
              </td>
              <td>
                <el-button
                  placeholder="请输入"
                  style="width: 70px;height: 40px;margin-left: 10px;"
                  @click="deleteList(index, 'quaList')"
                  >删
                </el-button>
              </td>
            </tr>

            <tr>
              <td colspan="2">安全生产许可证</td>
              <td>
                <el-form-item prop="safecert_num"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.safecert_num"
                    @change="labelInput($event, 'safecert_num')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="safecert_expiretime"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.safecert_expiretime"
                    @change="labelInput($event, 'safecert_expiretime')"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>
            <tr>
              <td rowspan="3">体系认证<span style="color: red"></span></td>
              <td>ISO9001 质量管理体系认证</td>
              <td>
                <el-form-item prop="qacert_num"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.qacert_num"
                    @change="labelInput($event, 'qacert_num')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="qacert_expiretime"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.qacert_expiretime"
                    @change="labelInput($event, 'qacert_expiretime')"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>

            <tr>
              <td>ISO14001 环境管理体系认证</td>
              <td>
                <el-form-item prop="macert_num"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.macert_num"
                    @change="labelInput($event, 'macert_num')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="macert_expiretim"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.macert_expiretim"
                    @change="labelInput($event, 'macert_expiretim')"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>

            <tr>
              <td>ISO45001 职业健康安全管理体系认证</td>
              <td>
                <el-form-item prop="jobcert_num"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.jobcert_num"
                    @change="labelInput($event, 'jobcert_num')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="jobcert_expiretim"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.jobcert_expiretim"
                    @change="labelInput($event, 'jobcert_expiretim')"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>
          </tbody>
        </table>
        <p>1.4人力资源配备</p>
        <table border="1" style="width: 95%" class="newtable">
          <tbody>
            <tr>
              <td colspan="2">
                在职员工总数（人）：<el-form-item prop="staff_count"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.staff_count"
                    @change="labelInput($event, 'staff_count')"
                  ></el-input
                ></el-form-item>
              </td>
              <td colspan="3">
                平均年龄（岁）：<el-form-item prop="evg_age"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.evg_age"
                    @change="labelInput($event, 'evg_age')"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>

            <tr>
              <td colspan="2">分类</td>
              <td>人数</td>
              <td>比例</td>
              <td>备注</td>
            </tr>
            <tr>
              <td rowspan="2">职称情况</td>
              <td>中级职称</td>
              <td>
                <el-form-item prop="mid_title_person_count"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.mid_title_person_count"
                    @change="labelInput($event, 'mid_title_person_count')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="mid_title_person_rate"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.mid_title_person_rate"
                    @change="labelInput($event, 'mid_title_person_rate')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="mid_title_person_remark"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.mid_title_person_remark"
                    @change="labelInput($event, 'mid_title_person_remark')"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>
            <tr>
              <td>高级职称及以上</td>
              <td>
                <el-form-item prop="hi_title_person_count"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.hi_title_person_count"
                    @change="labelInput($event, 'hi_title_person_count')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="hi_title_person_rate"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.hi_title_person_rate"
                    @change="labelInput($event, 'hi_title_person_rate')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="hi_title_person_remark"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.hi_title_person_remark"
                    @change="labelInput($event, 'hi_title_person_remark')"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>

            <tr>
              <td rowspan="3">学历情况</td>
              <td>大专</td>
              <td>
                <el-form-item prop="dz_count"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.dz_count"
                    @change="labelInput($event, 'dz_count')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="dz_rate"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.dz_rate"
                    @change="labelInput($event, 'dz_rate')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="dz_remark"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.dz_remark"
                    @change="labelInput($event, 'dz_remark')"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>

            <tr>
              <td>本科</td>
              <td>
                <el-form-item prop="bk_count"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.bk_count"
                    @change="labelInput($event, 'bk_count')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="bk_rate"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.bk_rate"
                    @change="labelInput($event, 'bk_rate')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="bk_remark"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.bk_remark"
                    @change="labelInput($event, 'bk_remark')"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>
            <tr>
              <td>研究生及以上</td>
              <td>
                <el-form-item prop="yjs_count"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.yjs_count"
                    @change="labelInput($event, 'yjs_count')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="yjs_rate"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.yjs_rate"
                    @change="labelInput($event, 'yjs_rate')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="yjs_remark"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.yjs_remark"
                    @change="labelInput($event, 'yjs_remark')"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>
            <tr>
              <td rowspan="3">注册证书持有情况</td>
              <td>一级注册建造师</td>
              <td>
                <el-form-item prop="yjzc_count"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.yjzc_count"
                    @change="labelInput($event, 'yjzc_count')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="yjzc_rate"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.yjzc_rate"
                    @change="labelInput($event, 'yjzc_rate')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="yjzc_remark"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.yjzc_remark"
                    @change="labelInput($event, 'yjzc_remark')"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>

            <tr>
              <td>二级注册建造师</td>
              <td>
                <el-form-item prop="ejzc_count"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.ejzc_count"
                    @change="labelInput($event, 'ejzc_count')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="ejzc_rate"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.ejzc_rate"
                    @change="labelInput($event, 'ejzc_rate')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="ejzc_remark"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.ejzc_remark"
                    @change="labelInput($event, 'ejzc_remark')"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>

            <tr>
              <td>其他类注册人员</td>
              <td>
                <el-form-item prop="qtzc_count"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.qtzc_count"
                    @change="labelInput($event, 'qtzc_count')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="qtzc_rate"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.qtzc_rate"
                    @change="labelInput($event, 'qtzc_rate')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="qtzc_remark"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.qtzc_remark"
                    @change="labelInput($event, 'qtzc_remark')"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>
            <tr>
              <td colspan="2">管理岗位证书持有情况</td>
              <td>
                <el-form-item prop="glgw_count"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.glgw_count"
                    @change="labelInput($event, 'glgw_count')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="glgw_rate"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.glgw_rate"
                    @change="labelInput($event, 'glgw_rate')"
                  ></el-input
                ></el-form-item>
              </td>
              <td>
                <el-form-item prop="glgw_remark"
                  ><el-input
                    placeholder="请输入"
                    v-model="newform.glgw_remark"
                    @change="labelInput($event, 'glgw_remark')"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- 主要经营管理指标统计 -->
        <p class="view_head midflex">2.企业经济指标</p>

        <table border="1" style="width: 95%" class="newtable">
          <tbody>
            <tr>
              <td>序号</td>
              <td>项目指标</td>
              <td>上一年度数据</td>
            </tr>
            <tr>
              <td>1</td>
              <td>总产值(万元)</td>
              <td>
                <el-form-item prop="output"
                  ><el-input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.output"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>资产总额(万元)</td>
              <td>
                <el-form-item prop="assets">
                  <el-input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.assets"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>
            <tr>
              <td>3</td>
              <td>负债总额(万元)</td>
              <td>
                <el-form-item prop="liabilities">
                  <el-input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.liabilities"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>
            <tr>
              <td>4</td>
              <td>利润总额(万元)</td>
              <td>
                <el-form-item prop="profit">
                  <el-input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.profit"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>
            <tr>
              <td>5</td>
              <td>上交税费总额(万元)</td>
              <td>
                <el-form-item prop="taxes">
                  <el-input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.taxes"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>
            <tr>
              <td>6</td>
              <td>净资产(万元)</td>
              <td>
                <el-form-item prop="net_assets">
                  <el-input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.net_assets"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>
            <tr>
              <td>7</td>
              <td>净利润(万元)</td>
              <td>
                <el-form-item prop="net_profit">
                  <el-input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.net_profit"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>
            <tr>
              <td>8</td>
              <td>职工教育经费(万元)</td>
              <td>
                <el-form-item prop="edu_fee"
                  ><el-input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.edu_fee"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>
            <tr>
              <td>9</td>
              <td>科技研发经费(万元)</td>
              <td>
                <el-form-item prop="tec_fee">
                  <el-input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.tec_fee"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>
            <tr>
              <td>10</td>
              <td>资产负债率(%)</td>
              <td>
                <el-form-item prop="liability_ratio">
                  <el-input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.liability_ratio"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>
            <tr>
              <td>11</td>
              <td>产值利润率(%)</td>
              <td>
                <el-form-item prop="profit_rate"
                  ><el-input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.profit_rate"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>
            <tr>
              <td>12</td>
              <td>净资产增长率(%)</td>
              <td>
                <el-form-item prop="growth_rate">
                  <el-input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.growth_rate"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>
            <tr>
              <td>13</td>
              <td>教育费用收入比率(%)</td>
              <td>
                <el-form-item prop="edu_income_rate"
                  ><el-input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.edu_income_rate"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>
            <tr>
              <td>14</td>
              <td>科研费用收入比率(%)</td>
              <td>
                <el-form-item prop="tec_income_rate">
                  <el-input
                    type="text"
                    placeholder="请输入"
                    v-model="newform.tec_income_rate"
                  ></el-input
                ></el-form-item>
              </td>
            </tr>
          </tbody>
        </table>
        注：1、以上数据以会计师事务所出具的上一年度的《审计报告》数据为依据。
        2、资产负债率、产值利润率、净资产增长率计算方式见《办法》术语中2.0.5财务指标。
        <p class="view_head midflex">
          3.企业市场信用<span style="color: red">（选填）</span>
        </p>

        <h6>3.1获奖信息</h6>
        <div class="newAddBtn" style="margin-left: 50px;margin-bottom: 10px">
          <el-button type="primary" @click="addInstall('rewardsList')"
            >增行</el-button
          >
        </div>
        <table border="1" style="width: 95%" class="newtable">
          <tbody>
            <tr>
              <td>序号</td>
              <td>奖项名称</td>
              <td>获奖数量</td>
              <td>授予时间</td>
              <td>颁发单位</td>
              <td>动作</td>
            </tr>

            <tr v-for="(item, index) in newform.rewardsList" :key="index">
              <td>{{ index + 1 }}</td>
              <td>
                <el-input
                  placeholder="请输入"
                  v-model="newform.rewardsList[index].award_name"
                  type="text"
                ></el-input>
              </td>
              <td>
                <el-input
                  placeholder="请输入"
                  v-model="newform.rewardsList[index].award_num"
                  type="text"
                ></el-input>
              </td>
              <td>
                <el-input
                  placeholder="请输入"
                  v-model="newform.rewardsList[index].get_time"
                  type="text"
                ></el-input>
              </td>
              <td>
                <el-input
                  placeholder="请输入"
                  v-model="newform.rewardsList[index].enp_name"
                  type="text"
                ></el-input>
              </td>
              <td>
                <el-button
                  style="width: 70px;height: 40px;margin-left: 10px;"
                  @click="deleteList(index, 'rewardsList')"
                  >删
                </el-button>
              </td>
            </tr>
          </tbody>
        </table>

        <h6>3.2履行社会责任</h6>
        <div class="newAddBtn" style="margin-left: 20px;margin-bottom: 10px">
          <el-button type="primary" @click="addInstall('responsibilitysList')"
            >增行</el-button
          >
        </div>
        <table border="1" style="width: 95%" class="newtable">
          <tbody>
            <tr>
              <td>序号</td>
              <td>项目名称</td>
              <td>时间</td>
              <td>受益方</td>
              <td>方式（或事迹说明）</td>
              <td>动作</td>
            </tr>

            <tr
              v-for="(item, index) in newform.responsibilitysList"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>
                <el-input
                  placeholder="请输入"
                  type="text"
                  v-model="newform.responsibilitysList[index].project_name"
                ></el-input>
              </td>
              <td>
                <el-input
                  placeholder="请输入"
                  type="text"
                  v-model="newform.responsibilitysList[index].do_time"
                ></el-input>
              </td>
              <td>
                <el-input
                  placeholder="请输入"
                  type="text"
                  v-model="newform.responsibilitysList[index].beneficiary"
                ></el-input>
              </td>
              <td>
                <el-input
                  placeholder="请输入"
                  type="text"
                  v-model="newform.responsibilitysList[index].way"
                ></el-input>
              </td>
              <td>
                <el-button
                  style="width: 70px;height: 40px;margin-left: 10px;"
                  @click="deleteList(index, 'responsibilitysList')"
                  >删
                </el-button>
              </td>
            </tr>
          </tbody>
        </table>

        <h6>3.3不良信息</h6>
        <div class="newAddBtn" style="margin-left: 50px;margin-bottom: 10px">
          <el-button type="primary" @click="addInstall('noGoodList')"
            >增行</el-button
          >
        </div>
        <table border="1" style="width: 95%" class="newtable">
          <tbody>
            <tr>
              <td>序号</td>
              <td>不良行为信息</td>
              <td>记录时间</td>
              <td>处罚机关</td>
              <td>处罚原因</td>
              <td>动作</td>
            </tr>

            <tr v-for="(item, index) in newform.noGoodList" :key="index">
              <td>{{ index + 1 }}</td>
              <td>
                <el-input
                  placeholder="请输入"
                  type="text"
                  v-model="newform.noGoodList[index].msg"
                ></el-input>
              </td>
              <td>
                <el-input
                  placeholder="请输入"
                  type="text"
                  v-model="newform.noGoodList[index].recordtime"
                ></el-input>
              </td>
              <td>
                <el-input
                  placeholder="请输入"
                  type="text"
                  v-model="newform.noGoodList[index].unit"
                ></el-input>
              </td>
              <td>
                <el-input
                  placeholder="请输入"
                  type="text"
                  v-model="newform.noGoodList[index].reason"
                ></el-input>
              </td>
              <td>
                <el-button
                  style="width: 70px;height: 40px;margin-left: 10px;"
                  @click="deleteList(index, 'noGoodList')"
                  >删
                </el-button>
              </td>
            </tr>
          </tbody>
        </table>

        <p class="view_head midflex">4.主要工程信息</p>

        <br />
        <p>4.1竣工工程</p>
        <div class="newAddBtn" style="margin-left: 50px;margin-bottom: 10px">
          <el-button type="primary" @click="addInstall('comEngList')"
            >增行</el-button
          >
        </div>
        <table border="1" style="width: 95%" class="newtable">
          <tbody>
            <tr>
              <td>序号</td>
              <td>工程名称</td>
              <td>建设单位</td>
              <td>开工日期</td>
              <td>竣工时间</td>
              <td>质量评定结果</td>
              <td>动作</td>
            </tr>

            <tr v-for="(item, index) in newform.comEngList" :key="index">
              <td>{{ index + 1 }}</td>
              <td>
                <el-input
                  placeholder="请输入"
                  type="text"
                  v-model="newform.comEngList[index].engname"
                ></el-input>
              </td>
              <td>
                <el-input
                  placeholder="请输入"
                  type="text"
                  v-model="newform.comEngList[index].construc_enp"
                ></el-input>
              </td>
              <td>
                <el-input
                  placeholder="请输入"
                  type="text"
                  v-model="newform.comEngList[index].open_date"
                ></el-input>
              </td>
              <td>
                <el-input
                  placeholder="请输入"
                  type="text"
                  v-model="newform.comEngList[index].comptime"
                ></el-input>
              </td>
              <td>
                <el-input
                  placeholder="请输入"
                  type="text"
                  v-model="newform.comEngList[index].result"
                ></el-input>
              </td>
              <td>
                <el-button
                  style="width: 70px;height: 40px;margin-left: 10px;"
                  @click="deleteList(index, 'comEngList')"
                  >删
                </el-button>
              </td>
            </tr>
          </tbody>
        </table>

        <p>4.2 在施工程</p>
        <div class="newAddBtn" style="margin-left: 50px;margin-bottom: 10px">
          <el-button type="primary" @click="addInstall('construcingEngList')"
            >增行</el-button
          >
        </div>
        <table border="1" style="width: 95%" class="newtable">
          <tbody>
            <tr>
              <td>序号</td>
              <td>工程名称</td>
              <td>建设单位</td>
              <td>开工日期</td>
              <td>竣工时间</td>
              <td>质量评定结果</td>
              <td>动作</td>
            </tr>

            <tr
              v-for="(item, index) in newform.construcingEngList"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>
                <el-input
                  placeholder="请输入"
                  type="text"
                  v-model="newform.construcingEngList[index].engname"
                ></el-input>
              </td>
              <td>
                <el-input
                  placeholder="请输入"
                  type="text"
                  v-model="newform.construcingEngList[index].construc_enp"
                ></el-input>
              </td>
              <td>
                <el-input
                  placeholder="请输入"
                  type="text"
                  v-model="newform.construcingEngList[index].open_date"
                ></el-input>
              </td>
              <td>
                <el-input
                  placeholder="请输入"
                  type="text"
                  v-model="newform.construcingEngList[index].comptime"
                ></el-input>
              </td>
              <td>
                <el-input
                  placeholder="请输入"
                  type="text"
                  v-model="newform.construcingEngList[index].result"
                ></el-input>
              </td>
              <td>
                <el-button
                  style="width: 70px;height: 40px;margin-left: 10px;"
                  @click="deleteList(index, 'construcingEngList')"
                  >删
                </el-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="uploadBtn">
        <el-button type="primary" @click="basicInfo('formRef')">保存</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import labelInput from "../../../components/table/labelInput.vue";
import normalPicker from "../../../components/table/normalPicker.vue";

import { saveQua } from "../../../api/moudles/manager";
import labelText from "../../../components/table/labelText.vue";

export default {
  data() {
    return {
      spanWidth: "180px",
      newform: {
        company_name: "",
        apply_type: [],
        reg_add: "",
        bus_add: "",
        birth_date: "",
        taxnum: "",
        legaler: "",
        reg_money: "",
        bus_range: "",
        ec_nature: "", // 新增的经济性质
        over_num: "", // 新增的上一年度竣工工程数量
        pass_rate: "", // 新增的工程质量验收合格率
        contacts_name: "", // 新增的申报人姓名
        contacts_post: "", // 新增的申报人职务
        contacts_phone: "",
        cellphone: "",
        legal_name: "", // 法定代表人姓名
        legal_sex: "", // 法定代表人性别
        legal_age: "", // 法定代表人年龄（注意：这里虽然是number类型，但初始化为空字符串，因为v-model会处理它）
        legal_post: "", // 法定代表人职务
        legal_education: "", // 法定代表人学历
        legal_title: "", // 法定代表人职称
        safecert_num: "", // 安全生产许可证编号
        safecert_expiretime: "", // 安全生产许可证到期时间
        qacert_num: "", // ISO9001质量管理体系认证编号
        qacert_expiretime: "", // ISO9001质量管理体系认证到期时间
        macert_num: "", // ISO14001环境管理体系认证编号
        macert_expiretim: "", // 注意：这里可能是个拼写错误，应该是macert_expiretime
        jobcert_num: "", // ISO45001职业健康安全管理体系认证编号
        jobcert_expiretim: "", // 注意：这里也可能是个拼写错误，应该
        staff_count: "", // 新增的职工人数
        avg_age: "", // 新增的平均年龄
        mid_title_person_count: "", // 中级职称人数
        mid_title_person_rate: "", // 中级职称人员占比（可能需要转换为数字进行计算）
        mid_title_person_remark: "", // 中级职称备注
        hi_title_person_count: "", // 高级职称及以上人数
        hi_title_person_rate: "", // 高级职称及以上人员占比（同样可能需要转换为数字）
        hi_title_person_remark: "", // 高级职称及以上备注
        // 学历情况
        dz_count: "", // 大专人数
        dz_rate: "", // 大专人员占比（可能需要转换为数字）
        dz_remark: "", // 大专备注
        bk_count: "", // 本科人数
        bk_rate: "", // 本科人员占比（可能需要转换为数字）
        bk_remark: "", // 本科备注
        yjs_count: "", // 研究生及以上人数
        yjs_rate: "", // 研究生及以上人员占比（可能需要转换为数字）
        yjs_remark: "", // 研究生及以上备注
        // 注册证书持有情况
        yjzc_count: "", // 一级注册建造师人数
        yjzc_rate: "", // 一级注册建造师占比（可能需要转换为数字）
        yjzc_remark: "", // 一级注册建造师备注
        ejzc_count: "", // 二级注册建造师人数
        ejzc_rate: "", // 二级注册建造师占比
        ejzc_remark: "", // 二级注册建造师备注
        qtzc_count: "", // 其他类注册人员人数
        qtzc_rate: "", // 其他类注册人员占比
        qtzc_remark: "", // 其他类注册人员备注
        // 管理岗位证书持有情况
        glgw_count: "", // 管理岗位证书人数
        glgw_rate: "", // 管理岗位证书占比
        glgw_remark: "", // 管理岗位证书备注
        quaList: [],
        rewardsList: [],
        responsibilitysList: [],
        noGoodList: [],
        comEngList: [],
        construcingEngList: [],
        output: "",
        assets: "",
        liabilities: "",
        profit: "",
        taxes: "",
        net_assets: "",
        net_profit: "",
        edu_fee: "",
        tec_fee: "",
        liability_ratio: "",
        profit_rate: "",
        growth_rate: "",
        edu_income_rate: "",
        tec_income_rate: "",
      },
      formRule: {
        company_name: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        reg_add: [
          { required: true, message: "请输入注册地址", trigger: "blur" },
        ],
        bus_add: [
          { required: true, message: "请输入经营地址", trigger: "blur" },
        ],
        birth_date: [
          { required: true, message: "请选择成立时间", trigger: "change" },
          // 可以添加额外的日期格式验证规则
        ],
        taxnum: [{ required: true, message: "请输入税号", trigger: "blur" }],
        legaler: [{ required: true, message: "请输入", trigger: "blur" }], // 注意：这里可能需要具体的字段含义
        reg_money: [
          { required: true, message: "请输入注册资金", trigger: "blur" },
        ],
        bus_range: [
          { required: true, message: "请输入经营范围", trigger: "blur" },
        ],
        ec_nature: [
          { required: true, message: "请输入经济性质", trigger: "blur" },
        ],
        over_num: [
          {
            required: true,
            message: "请输入上一年度竣工工程数量",
            trigger: "blur",
          },
        ],
        pass_rate: [
          {
            required: true,
            message: "请输入工程质量验收合格率",
            trigger: "blur",
          },
          // 可以添加数字范围验证规则
        ],
        contacts_name: [
          { required: true, message: "请输入申报人姓名", trigger: "blur" },
        ],
        contacts_post: [
          { required: true, message: "请输入申报人职务", trigger: "blur" },
        ],
        contacts_phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
        cellphone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
        ],
        legal_name: [
          { required: true, message: "请输入法定代表人姓名", trigger: "blur" },
        ],
        legal_sex: [
          {
            required: true,
            message: "请选择法定代表人性别",
            trigger: "change",
          },
        ],
        legal_age: [
          { required: true, message: "请输入法定代表人年龄", trigger: "blur" },
          // 可以添加数字范围验证规则
        ],
        legal_post: [
          { required: true, message: "请输入法定代表人职务", trigger: "blur" },
        ],
        legal_education: [
          { required: true, message: "请输入法定代表人学历", trigger: "blur" },
        ],
        legal_title: [
          { required: true, message: "请输入法定代表人职称", trigger: "blur" },
        ],
        safecert_num: [
          {
            required: true,
            message: "请输入安全生产许可证编号",
            trigger: "blur",
          },
        ],
        safecert_expiretime: [
          {
            required: true,
            message: "请选择安全生产许可证到期时间",
            trigger: "change",
          },
          // 可以添加日期格式验证规则
        ],

        staff_count: [
          { required: true, message: "请输入职工人数", trigger: "blur" },
          // 可以添加数字范围验证规则
        ],
        evg_age: [{ required: true, message: "请输入", trigger: "blur" }],
        mid_title_person_count: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        mid_title_person_rate: [
          { required: true, message: "请输入", trigger: "blur" },
        ],

        hi_title_person_count: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        hi_title_person_rate: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        dz_count: [{ required: true, message: "请输入", trigger: "blur" }],
        dz_rate: [{ required: true, message: "请输入", trigger: "blur" }],
        bk_count: [{ required: true, message: "请输入", trigger: "blur" }],
        bk_rate: [{ required: true, message: "请输入", trigger: "blur" }],
        yjs_count: [{ required: true, message: "请输入", trigger: "blur" }],
        yjs_rate: [{ required: true, message: "请输入", trigger: "blur" }],
        yjzc_count: [{ required: true, message: "请输入", trigger: "blur" }],
        yjzc_rate: [{ required: true, message: "请输入", trigger: "blur" }],
        ejzc_count: [{ required: true, message: "请输入", trigger: "blur" }],
        ejzc_rate: [{ required: true, message: "请输入", trigger: "blur" }],
        qtzc_count: [{ required: true, message: "请输入", trigger: "blur" }],
        qtzc_rate: [{ required: true, message: "请输入", trigger: "blur" }],
        glgw_count: [{ required: true, message: "请输入", trigger: "blur" }],
        glgw_rate: [{ required: true, message: "请输入", trigger: "blur" }],

        output: [{ required: true, message: "请输入", trigger: "blur" }],
        assets: [{ required: true, message: "请输入资产值", trigger: "blur" }],
        liabilities: [
          { required: true, message: "请输入负债值", trigger: "blur" },
        ],
        profit: [{ required: true, message: "请输入利润值", trigger: "blur" }],
        taxes: [{ required: true, message: "请输入税额", trigger: "blur" }],
        net_assets: [
          { required: true, message: "请输入净资产值", trigger: "blur" },
        ],
        net_profit: [
          { required: true, message: "请输入净利润值", trigger: "blur" },
        ],
        edu_fee: [
          { required: true, message: "请输入教育费用", trigger: "blur" },
        ],
        tec_fee: [
          { required: true, message: "请输入科技研发经费", trigger: "blur" },
        ],

        liability_ratio: [
          { required: true, message: "请输入资产负债率", trigger: "blur" },
        ],
        profit_rate: [
          { required: true, message: "请输入产值利润率", trigger: "blur" },
        ],
        growth_rate: [
          { required: true, message: "请输入净资产增长率", trigger: "blur" },
        ],
        edu_income_rate: [
          {
            required: true,
            message: "请输入教育费用收入比率",
            trigger: "blur",
          },
        ],
        tec_income_rate: [
          {
            required: true,
            message: "请输入科研费用收入比率",
            trigger: "blur",
          },
        ],
      },

      addList: [{}],
      oldAddList: [{}],

      form: {
        company_name: "",
        contacts_name: "",
        contacts_post: "",
        contacts_phone: "",
        cellphone: "",
        liability_ratio: "",
        profit_rate: "",
        growth_rate: "",
      },
    };
  },
  components: {
    labelInput,
    normalPicker,
    labelText,
  },
  props: {
    // 切换基本信息和获奖信息
    isBasic: {
      type: Boolean,
      default: true,
    },
    project_app_num: {
      type: String,
      default: "",
    },

    basicMsg: {
      type: Object,
      default: () => {
        return {};
      },
    },
    awardMsg: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    basicMsg(newvalue) {
      this.newform = {
        ...newvalue,
      };
    },

    awardMsg(newvalue) {
      this.oldAddList = newvalue;
    },
  },
  created() {
    /* if (this.isBasic) {
                this.$emit('basicInfo', this.form)
            }*/
  },
  methods: {
    // 提交获奖信息
    async getWinninginfo() {
      console.log("rewards", this.rewardsList);
      const params = {
        ...this.levelOne,
      };

      if (this.project_app_num) {
        params.project_app_num = this.project_app_num;
      }

      let newAddList = [...this.addList, ...this.oldAddList];
      for (let item in newAddList) {
        if (
          !newAddList[item].qualification_category ||
          !newAddList[item].qualification_level
        ) {
          this.$message.error("未填写完整");
          return;
        }
      }

      params.awardJson = newAddList;

      await saveQua({
        data: params,
        success: (res) => {
          if (res.code === 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            //this.project_app_num = res.data.project_app_num
          } else {
            // this.project_app_num = res.data.project_app_num
            this.$message.error(res.msg);
          }
        },
      });
    },

    // 新增获奖信息输入
    typeThreeInput(e, type, index) {
      console.log("e", e);
      if (type == "1") {
        this.rewardsList[index].award_name = e;
      } else if (type == "2") {
        this.rewardsList[index].award_num = e;
      } else if (type == "3") {
        this.rewardsList[index].get_time = e;
      } else {
        this.rewardsList[index].enp_name = e;
      }
      console.log(this.rewardsList);
    },
    // 新增参建单位
    addInstall(list) {
      if (list == "quaList") {
        this.newform.quaList.push({});
      }
      if (list == "rewardsList") {
        this.newform.rewardsList.push({});
      }
      if (list == "responsibilitysList") {
        this.newform.responsibilitysList.push({});
      }
      if (list == "noGoodList") {
        this.newform.noGoodList.push({});
      }
      if (list == "comEngList") {
        this.newform.comEngList.push({});
      }
      if (list == "construcingEngList") {
        this.newform.construcingEngList.push({});
      }
    },
    // 删除行
    deleteList(index, type) {
      /*const number = this.addList.length + this.oldAddList.length
                if (number === 1) {
                    this.$message.error(`至少填写一条参建信息`)
                    return
                }*/
      if (type === "rewardsList") {
        this.newform.rewardsList.splice(index, 1);
      } else if (type === "quaList") {
        this.newform.quaList.splice(index, 1);
      } else if (type === "responsibilitysList") {
        this.newform.responsibilitysList.splice(index, 1);
      } else if (type === "noGoodList") {
        this.newform.noGoodList.splice(index, 1);
      } else if (type === "comEngList") {
        this.newform.comEngList.splice(index, 1);
      } else if (type === "construcingEngList") {
        this.newform.construcingEngList.splice(index, 1);
      } else {
        this.newform.addList.splice(index, 1);
      }
    },

    labelInput(e, name) {
      console.log("e", name);
      //this.form[name] = e
      //this.$emit('basicInfo', this.form)
    },
    basicInfo(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log("newForm", this.newform);

          if (this.newform.comEngList.length == 0) {
            this.$message.error(`至少填写一条竣工工程信息`);
            return;
          }

          if (this.newform.quaList.length == 0) {
            this.$message.error(`至少填写一条资质及资格信息`);
            return;
          }
          if (this.newform.construcingEngList.length == 0) {
            this.$message.error(`至少填写一条在施工程信息`);
            return;
          }
          this.$emit("basicInfo", this.newform);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.midflex {
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
}

.inputList {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}

.view_head {
  font-size: 18px;
  font-weight: 600;
  margin-top: 20px;
}

.titleLeft {
  margin-left: 50px;
}

.awardInfo {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}

/* 提示 */
.allTips {
  margin: 20px 0;
  padding-left: 80px;
  text-align: left;
}

.tipList {
  /* margin-left: 80px; */
  display: flex;
  justify-content: flex-start;
}

.tipList p {
  display: inline-block;
  text-align: left;
  line-height: 25px;
}

.tipList p:nth-child(1) {
  width: 80px;
}

.tipList p:nth-child(2) {
  width: 200px;
}

.tipList p:nth-child(3) {
  width: 350px;
}
.newtable {
  margin-bottom: 20px;
}
.newtable tr td {
  height: 40px;
}
</style>
